import { render, staticRenderFns } from "./inventoryAge.vue?vue&type=template&id=3e65eea2&scoped=true"
import script from "./inventoryAge.vue?vue&type=script&lang=js"
export * from "./inventoryAge.vue?vue&type=script&lang=js"
import style0 from "./inventoryAge.vue?vue&type=style&index=0&id=3e65eea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e65eea2",
  null
  
)

export default component.exports